import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './WeatherWidget.css';
import React, { useState, useEffect, useRef } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { getColorByTheme, getPageThemeColors, get, hexToRgb, canUseDOM, getDictionaryItem } from '../../utils';
import { IconArrowDown, IconCalendar, IconHumidity, IconSunrise, IconSunset, IconTempMax, IconTempMin, IconWind } from './icons';
import { DatePickerDropDown, emptyDateShowObj, getStringFullDate, getStringWeek } from './components/DatePicker';
import debounce from 'lodash/debounce';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { isNil } from '../../utils/IsNil';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
function isSelectedDateGreaterThanCurrentFor14Days(date) {
  var timeDifference = date.getTime() - new Date().getTime();
  var daysDifference = timeDifference / (1000 * 3600 * 24);
  return daysDifference >= 14;
}
var isTimeIsNow = function isTimeIsNow(date) {
  var todayDate = new Date();
  var isDateEqual = todayDate.toISOString().slice(0, 10) === date.toISOString().slice(0, 10);
  var isHoursEqual = todayDate.getHours() === date.getHours();
  return isDateEqual && isHoursEqual;
};
var convertTime = function convertTime(timeStr) {
  if (timeStr && (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm'))) {
    var _timeStr$split = timeStr.split(' '),
      _timeStr$split2 = _slicedToArray(_timeStr$split, 2),
      time = _timeStr$split2[0],
      modifier = _timeStr$split2[1];
    var _time$split = time.split(':'),
      _time$split2 = _slicedToArray(_time$split, 2),
      hours = _time$split2[0],
      minutes = _time$split2[1];
    if (hours === '12') {
      hours = '00';
    }
    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }
    return "".concat(hours, ":").concat(minutes);
  }
  return timeStr;
};
var defaultSelectedForecast = {
  sunrise: '',
  sunset: '',
  avgHumidity: '',
  maxWind: '',
  far: {
    tempMin: '',
    tempMax: ''
  },
  cel: {
    tempMin: '',
    tempMax: ''
  },
  hours: [{
    time: '',
    far: {
      temp: ''
    },
    cel: {
      temp: ''
    }
  }]
};
var defaultTodayForecast = {
  conditionIcon: '',
  conditionText: '',
  far: {
    temp: ''
  },
  cel: {
    temp: ''
  }
};
var defaultWeeklyForecast = [{
  conditionIcon: '',
  conditionText: '',
  dayOfWeek: '',
  far: {
    tempMin: '',
    tempMax: ''
  },
  cel: {
    tempMin: '',
    tempMax: ''
  }
}];
var WeatherWidget = function WeatherWidget(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var _fields$data = fields.data,
    dictionary = _fields$data.dictionary,
    datasource = _fields$data.datasource;
  var sitecoreContext = useSitecoreContext();
  var lang = sitecoreContext && sitecoreContext.language || 'en';
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var apiKeyValue = get(sitecoreContext, "configuration.weatherApi.apiKey");
  var apiUrlValue = get(sitecoreContext, "configuration.weatherApi.apiUrl");
  var defaultLocationValue = get(sitecoreContext, "configuration.weatherApi.defaultLocation");
  var jssComponentErrorMessage = getDictionaryItem(dictionary, "errorMessage") || "Something went wrong";
  var dateMobileDateText = getDictionaryItem(dictionary, 'dateMobileSelectDate') || 'Select date';
  var weeklyTitleText = getDictionaryItem(dictionary, 'weeklyTitle') || 'This week';
  var todayText = getDictionaryItem(dictionary, 'today') || 'Today';
  var celcius = getDictionaryItem(dictionary, 'celcius') || "Celcius";
  var farenheit = getDictionaryItem(dictionary, 'farenheit') || "Farenheit";
  var sunrise = getDictionaryItem(dictionary, 'sunrise') || "Sunrise";
  var sunset = getDictionaryItem(dictionary, 'sunset') || "Sunset";
  var low = getDictionaryItem(dictionary, 'low') || "Low";
  var high = getDictionaryItem(dictionary, 'high') || "High";
  var humidity = getDictionaryItem(dictionary, 'humidity') || 'Humidity';
  var wind = getDictionaryItem(dictionary, 'wind') || "Wind";
  var windSpeed = getDictionaryItem(dictionary, 'windSpeed') || 'km/h';
  var hoursNow = getDictionaryItem(dictionary, 'now') || 'Now';
  var heading = get(datasource, 'heading.jss');
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDataProcessing = _useState2[0],
    setIsDataProcessing = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isVdsite = _useState4[0],
    setIsVdsite = _useState4[1];
  var _useState5 = useState(defaultTodayForecast),
    _useState6 = _slicedToArray(_useState5, 2),
    todayForecast = _useState6[0],
    setTodayForecast = _useState6[1];
  var _useState7 = useState(defaultSelectedForecast),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedForecast = _useState8[0],
    setSelectedForecast = _useState8[1];
  var _useState9 = useState(defaultWeeklyForecast),
    _useState10 = _slicedToArray(_useState9, 2),
    weeklyForecast = _useState10[0],
    setWeeklyForecast = _useState10[1];
  var _useState11 = useState('cel'),
    _useState12 = _slicedToArray(_useState11, 2),
    degreeMode = _useState12[0],
    setDegreeMode = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    error = _useState14[0],
    setError = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    serviceError = _useState16[0],
    setServiceError = _useState16[1];
  var _useState17 = useState(emptyDateShowObj),
    _useState18 = _slicedToArray(_useState17, 2),
    departureDate = _useState18[0],
    setDepartureDate = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    dateOpened = _useState20[0],
    setDateOpened = _useState20[1];
  var _useState21 = useState(canUseDOM ? window.matchMedia("(max-width: 767px)").matches : false),
    _useState22 = _slicedToArray(_useState21, 2),
    isMobile = _useState22[0],
    setIsMobile = _useState22[1];
  var _useState23 = useState(-1),
    _useState24 = _slicedToArray(_useState23, 2),
    hoursNowIndex = _useState24[0],
    setHoursNowIndex = _useState24[1];
  var hoursRef = useRef(null);
  var listRef = useRef(null);
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var openCalendar = function openCalendar() {
    setDateOpened(true);
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['clickWeatherCalendarAnalytics'], params), "open");
  };
  var closeCalendar = function closeCalendar() {
    setDateOpened(false);
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['clickWeatherCalendarAnalytics'], params), "close");
  };
  var debouncedCheckMobile = debounce(function () {
    setIsMobile(window.matchMedia("(max-width: 767px)").matches);
  }, 250);
  var setTodayForecastCallback = function setTodayForecastCallback(data) {
    return setTodayForecast({
      conditionIcon: get(data, 'current.condition.icon', '').replace('//cdn.weatherapi.com/weather', '/-/media/Weather'),
      conditionText: get(data, 'current.condition.text'),
      cel: {
        temp: get(data, 'current.temp_c')
      },
      far: {
        temp: get(data, 'current.temp_f')
      }
    });
  };
  var setSelectedForecastCallback = function setSelectedForecastCallback(data) {
    var hours = get(data, 'forecast.forecastday.0.hour').map(function (hour) {
      return {
        time: hour.time,
        far: {
          temp: hour.temp_f
        },
        cel: {
          temp: hour.temp_c
        }
      };
    });
    return setSelectedForecast({
      sunrise: convertTime(get(data, 'forecast.forecastday.0.astro.sunrise')),
      sunset: convertTime(get(data, 'forecast.forecastday.0.astro.sunset')),
      avgHumidity: get(data, 'forecast.forecastday.0.day.avghumidity'),
      maxWind: get(data, 'forecast.forecastday.0.day.maxwind_kph'),
      far: {
        tempMin: get(data, 'forecast.forecastday.0.day.mintemp_f'),
        tempMax: get(data, 'forecast.forecastday.0.day.maxtemp_f')
      },
      cel: {
        tempMin: get(data, 'forecast.forecastday.0.day.mintemp_c'),
        tempMax: get(data, 'forecast.forecastday.0.day.maxtemp_c')
      },
      hours: hours
    });
  };
  var setWeeklyForecastCallback = function setWeeklyForecastCallback(data) {
    var forecastday = get(data, 'forecast.forecastday').reduce(function (forecastList, currentDay, index) {
      // skip current day
      if (index === 0) {
        return forecastList;
      }
      var _currentDay$day = currentDay.day,
        condition = _currentDay$day.condition,
        maxtemp_c = _currentDay$day.maxtemp_c,
        maxtemp_f = _currentDay$day.maxtemp_f,
        mintemp_c = _currentDay$day.mintemp_c,
        mintemp_f = _currentDay$day.mintemp_f;
      var dataAboutDay = {
        dayOfWeek: new Intl.DateTimeFormat(lang, {
          weekday: "long"
        }).format(new Date(currentDay.date)),
        conditionIcon: condition.icon.replace('//cdn.weatherapi.com/weather', '/-/media/Weather'),
        conditionText: condition.text,
        far: {
          tempMin: mintemp_f,
          tempMax: maxtemp_f
        },
        cel: {
          tempMin: mintemp_c,
          tempMax: maxtemp_c
        }
      };
      forecastList.push(dataAboutDay);
      return forecastList;
    }, []);
    return setWeeklyForecast(forecastday);
  };
  var selectDateWeatherCalendarAnalytics = function selectDateWeatherCalendarAnalytics(date) {
    var formattedDate = date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: "long",
      year: 'numeric'
    }).replace(/ /g, '-');
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['selectDateWeatherCalendarAnalytics'], params), formattedDate);
  };
  var changeWeatherDataHandler = function changeWeatherDataHandler(date) {
    var url;
    if (isSelectedDateGreaterThanCurrentFor14Days(date)) {
      url = new URL("".concat(apiUrlValue, "/future.json"));
    } else {
      url = new URL("".concat(apiUrlValue, "/forecast.json"));
    }
    var queryString = new URLSearchParams({
      key: apiKeyValue,
      q: defaultLocationValue,
      lang: lang,
      aqi: 'no',
      alerts: 'no',
      dt: date.toISOString().slice(0, 10)
    });
    url.search = queryString.toString();
    fetch(url).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (data.error) {
        setServiceError(pageEditing ? get(data, 'error.message') : jssComponentErrorMessage);
      } else {
        setSelectedForecastCallback(data);
      }
    });
    selectDateWeatherCalendarAnalytics(date);
  };
  var getWeatherData = function getWeatherData() {
    var url = new URL("".concat(apiUrlValue, "/forecast.json"));
    var queryString = new URLSearchParams({
      key: apiKeyValue,
      q: defaultLocationValue,
      lang: lang,
      days: '7',
      aqi: 'no',
      alerts: 'no'
    });
    url.search = queryString.toString();
    fetch(url).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (data.error) {
        setServiceError(pageEditing ? get(data, 'error.message') : jssComponentErrorMessage);
      } else {
        setTodayForecastCallback(data);
        setSelectedForecastCallback(data);
        setWeeklyForecastCallback(data);
      }
    }).catch(function () {
      return setError(jssComponentErrorMessage);
    }).finally(function () {
      return setIsDataProcessing(false);
    });
  };
  var hideDateSelect = function hideDateSelect(e) {
    var mobileDevice = window.matchMedia("(max-width: 767px)").matches;
    if (mobileDevice || e.target.closest('.fields-wrapper__date') || e.target.closest('.datepicker-dropdown') || e.target.closest('.react-datepicker__day')) return;
    setDateOpened(false);
  };
  useEffect(function () {
    if (canUseDOM) {
      if (!document.body.classList.contains('vdsite')) {
        setIsVdsite(false);
      }
      return function () {};
    }
  }, []);
  useEffect(function () {
    if (apiKeyValue) {
      getWeatherData();
    }
  }, [apiKeyValue]);
  useEffect(function () {
    if (canUseDOM) {
      window.addEventListener('resize', debouncedCheckMobile);
      document.addEventListener("click", hideDateSelect);
      return function () {
        window.removeEventListener('resize', debouncedCheckMobile);
        document.addEventListener("click", hideDateSelect);
      };
    }
  }, []);
  useEffect(function () {
    if (hoursRef.current) {
      setHoursNowIndex(Number(hoursRef.current.id));
    }
  }, [hoursRef.current]);
  if (isNil(apiKeyValue) || isNil(apiUrlValue) || isNil(defaultLocationValue)) {
    console.warn('Weather widget component render skipped. No apikey provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[No apikey for weather widget provided]");
    }
    return null;
  }
  var dateFieldProps = {
    lang: lang,
    rtl: rtl,
    dateOpened: dateOpened,
    closeDateDropdown: function closeDateDropdown() {
      return setDateOpened(false);
    },
    closeDateDropdownWithAnalytics: closeCalendar,
    setDepDate: setDepartureDate,
    isMobile: isMobile,
    dateMobileDateText: dateMobileDateText,
    changeWeatherDataHandler: changeWeatherDataHandler
  };
  var getSelectedDay = function getSelectedDay(rtl) {
    if (rtl) {
      return "\n      ".concat(departureDate.month, "\n        ").concat(departureDate.day, ",\n        ").concat(getStringFullDate(departureDate.fullDate) === getStringFullDate(new Date()) ? todayText : getStringWeek(departureDate.fullDate));
    }
    return "".concat(getStringFullDate(departureDate.fullDate) === getStringFullDate(new Date()) ? todayText : getStringWeek(departureDate.fullDate), ",\n        ").concat(departureDate.day, "\n        ").concat(departureDate.month);
  };
  var renderItems = function renderItems() {
    return selectedForecast.hours.map(function (hour, index) {
      var date = new Date(hour.time.toString());
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "listicle-item"
      }, isTimeIsNow(date) ? /*#__PURE__*/React.createElement("div", {
        ref: hoursRef,
        id: index.toString(),
        className: "renderItemTimeNow"
      }, hoursNow) : /*#__PURE__*/React.createElement("div", {
        className: "renderItemTime"
      }, hour.time.split(" ")[1]), /*#__PURE__*/React.createElement("div", {
        className: "renderItemTemp"
      }, hour[degreeMode].temp, "\xB0"));
    });
  };
  var renderSuccess = function renderSuccess() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "d-flex weatherContainer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-lg-5"
    }, !isDataProcessing ? /*#__PURE__*/React.createElement("div", {
      className: "fr-wr-main-layout"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fr-wr-main-item fr-wr-main-item--current-temp-mode"
    }, /*#__PURE__*/React.createElement("div", {
      className: "todayForecastCondition"
    }, todayForecast.conditionText), /*#__PURE__*/React.createElement("div", {
      className: "fr-wr-main-item__current-temp"
    }, todayForecast[degreeMode].temp, "\xB0"), /*#__PURE__*/React.createElement("div", {
      className: "fr-wr-main-item__mode"
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        setDegreeMode('cel');
      },
      className: "".concat(degreeMode === 'cel' ? 'active' : '')
    }, celcius), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        setDegreeMode('far');
      },
      className: "".concat(degreeMode === 'far' ? 'active' : '')
    }, farenheit))), /*#__PURE__*/React.createElement("div", {
      className: "fr-wr-main-item"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fr-wr-main-item__icon-holder"
    }, /*#__PURE__*/React.createElement("img", {
      src: todayForecast.conditionIcon.replace('64x64', '128x128'),
      alt: todayForecast.conditionText
    })))) : null), /*#__PURE__*/React.createElement("div", {
      className: "forecastSelect"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fields-wrapper__date fields-wrapper__date--single"
    }, /*#__PURE__*/React.createElement("div", {
      tabIndex: 0,
      className: "row fields-wrapper__date-departure",
      onClick: openCalendar
    }, /*#__PURE__*/React.createElement("div", {
      className: rtl ? "row-reverse" : "row"
    }, /*#__PURE__*/React.createElement(IconCalendar, {
      className: "iconCalendarCommon"
    }), /*#__PURE__*/React.createElement("div", {
      className: "row-reverse"
    }, getSelectedDay(rtl))), /*#__PURE__*/React.createElement(IconArrowDown, {
      className: "icon-arrow m-0"
    })), dateOpened && /*#__PURE__*/React.createElement("div", {
      className: "fields-wrapper__date-arrow"
    }), /*#__PURE__*/React.createElement(DatePickerDropDown, dateFieldProps)), /*#__PURE__*/React.createElement(CarouselProvider, {
      activeItemIndex: hoursNowIndex
    }, function (_ref2) {
      var renderCarousel = _ref2.renderCarousel,
        renderPreviousButton = _ref2.renderPreviousButton,
        renderNextButton = _ref2.renderNextButton;
      return /*#__PURE__*/React.createElement("div", {
        className: "hoursForecastSlider"
      }, renderCarousel(renderItems(), {
        responsive: {
          desktop: {
            breakpoint: {
              max: 10000,
              min: 769
            },
            items: 2
          },
          table: {
            breakpoint: {
              max: 768,
              min: 461
            },
            items: 3
          },
          mobile: {
            breakpoint: {
              max: 460,
              min: 0
            },
            items: 2
          }
        },
        slidesToSlide: 2
      }), /*#__PURE__*/React.createElement("div", {
        className: "listicle__navigation-container"
      }, renderPreviousButton(), renderNextButton()));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "col-lg-12"
    }, !isDataProcessing ? /*#__PURE__*/React.createElement("div", {
      className: "row currentCardDetailsWrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row currentCardDetailsItem"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cardImage"
    }, /*#__PURE__*/React.createElement(IconSunrise, null)), /*#__PURE__*/React.createElement("div", {
      className: "col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fr-wr-data-item__name"
    }, sunrise), /*#__PURE__*/React.createElement("div", {
      className: "fr-wr-data-item__value"
    }, selectedForecast.sunrise))), /*#__PURE__*/React.createElement("div", {
      className: "row currentCardDetailsItem"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cardImage"
    }, /*#__PURE__*/React.createElement(IconSunset, null)), /*#__PURE__*/React.createElement("div", {
      className: "col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fr-wr-data-item__name"
    }, sunset), /*#__PURE__*/React.createElement("div", {
      className: "fr-wr-data-item__value"
    }, selectedForecast.sunset))), /*#__PURE__*/React.createElement("div", {
      className: "row currentCardDetailsItem"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cardImage"
    }, /*#__PURE__*/React.createElement(IconTempMin, null)), /*#__PURE__*/React.createElement("div", {
      className: "col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fr-wr-data-item__name"
    }, low), /*#__PURE__*/React.createElement("div", {
      className: "fr-wr-data-item__value"
    }, selectedForecast[degreeMode].tempMin, "\xB0"))), /*#__PURE__*/React.createElement("div", {
      className: "row currentCardDetailsItem"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cardImage"
    }, /*#__PURE__*/React.createElement(IconTempMax, null)), /*#__PURE__*/React.createElement("div", {
      className: "col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fr-wr-data-item__name"
    }, high), /*#__PURE__*/React.createElement("div", {
      className: "fr-wr-data-item__value"
    }, selectedForecast[degreeMode].tempMax, "\xB0"))), /*#__PURE__*/React.createElement("div", {
      className: "row currentCardDetailsItem"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cardImage"
    }, /*#__PURE__*/React.createElement(IconHumidity, null)), /*#__PURE__*/React.createElement("div", {
      className: "col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fr-wr-data-item__name"
    }, humidity), /*#__PURE__*/React.createElement("div", {
      className: "fr-wr-data-item__value"
    }, "".concat(selectedForecast.avgHumidity, "%")))), /*#__PURE__*/React.createElement("div", {
      className: "row currentCardDetailsItem"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cardImage"
    }, /*#__PURE__*/React.createElement(IconWind, null)), /*#__PURE__*/React.createElement("div", {
      className: "col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fr-wr-data-item__name"
    }, wind), /*#__PURE__*/React.createElement("div", {
      className: "fr-wr-data-item__value"
    }, "".concat(selectedForecast.maxWind, " ").concat(windSpeed))))) : null), /*#__PURE__*/React.createElement("div", {
      className: "weeklyForecastTitle"
    }, weeklyTitleText), /*#__PURE__*/React.createElement("div", {
      className: "col-lg-12"
    }, /*#__PURE__*/React.createElement("div", {
      ref: listRef,
      className: "row weeklyCardWrapper"
    }, !isDataProcessing ? weeklyForecast.map(function (forecast) {
      return /*#__PURE__*/React.createElement("div", {
        className: "row weeklyCardItem"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cardImage"
      }, /*#__PURE__*/React.createElement("img", {
        src: forecast.conditionIcon,
        alt: forecast.conditionText
      })), /*#__PURE__*/React.createElement("div", {
        className: "col"
      }, /*#__PURE__*/React.createElement("div", {
        className: "fr-wr-data-item__name"
      }, forecast.dayOfWeek), /*#__PURE__*/React.createElement("div", {
        className: "fr-wr-data-item__value"
      }, forecast[degreeMode].tempMax, "\xB0"), /*#__PURE__*/React.createElement("div", {
        className: "fr-wr-data-item__minValue"
      }, forecast[degreeMode].tempMin, "\xB0")));
    }) : null)));
  };
  var variables = {
    "--weather-widget-background-color": getPageThemeColors(isVdsite).primary,
    "--weather-widget-background-color-rgb": hexToRgb(getPageThemeColors(isVdsite).primary, true),
    "--weather-widget-background-active-color": getPageThemeColors(isVdsite).primary_active,
    "--weather-widget-color": getColorByTheme(getPageThemeColors(isVdsite).primary)
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11 selectedWeatherWidget",
    style: variables
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    field: heading,
    className: "col fr-wr-header"
  }), isDataProcessing ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "loader"
  }), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-5"
  }))) : null, !isDataProcessing && serviceError ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-5 mb-3 mb-lg-0"
  }, serviceError)) : null, !isDataProcessing && error ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-5 mb-3 mb-lg-0"
  }, error)) : null, !isDataProcessing && !error && !serviceError ? renderSuccess() : null)));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c1pd2rk3";
var ltrStyles = "l1ae8rzr";
var rtlStyles = "r1nujl1v";
export default WeatherWidget;